export const GET_BLOG= 'GET_BLOG';
export const GET_BLOG_ERR = 'GET_BLOG_ERR';

export const GET_BLOGS= 'GET_BLOGS';
export const GET_BLOGS_ERR = 'GET_BLOGS_ERR';

export const GET_BLOGS_CATEGORIES= 'GET_BLOGS_CATEGORIES';
export const GET_BLOGS_CATEGORIES_ERR = 'GET_BLOGS_CATEGORIES_ERR';
